import { Alias, APIAlias, apiAliasToAlias } from "../../apiResponse/alias";
import { OnsipAPIBoolean, onsipApiBooleanToBoolean } from "../../apiResponse/xml-json";

export declare interface APIDid {
  AccountId: string;
  CallerIdNumberRequired: OnsipAPIBoolean;
  Created: string;
  DidId: string;
  FailoverEnabled: OnsipAPIBoolean;
  FailoverLocation: string;
  FailoverProtocol: string;
  Modified: string;
  Name: string;
  Note: string;
  Number: string;
  OrganizationId: string;
  Protocol: string;
  SimultaneousCallLimit: string;
  Timeout: string;
  UserId: string;
  UserNumberAlias?: APIAlias;
  UserStatus: string;
  VoicemailboxId: string;
}

export declare interface Did {
  accountId: string;
  created: string;
  callerIdNumberRequired: boolean;
  didId: string;
  failoverEnabled: boolean;
  failoverLocation: string;
  failoverProtocol: string;
  modified: string;
  name: string;
  note: string;
  number: string;
  organizationId: string;
  protocol: string;
  simultaneousCallLimit: string;
  timeout: string;
  userId: string;
  userNumberAlias: Alias | undefined;
  userStatus: string;
  voicemailboxId: string;
}

export function apiDidToDid(apiDid: APIDid): Did {
  return {
    accountId: apiDid.AccountId,
    created: apiDid.Created,
    callerIdNumberRequired: onsipApiBooleanToBoolean(apiDid.CallerIdNumberRequired),
    didId: apiDid.DidId,
    failoverEnabled: onsipApiBooleanToBoolean(apiDid.FailoverEnabled),
    failoverLocation: apiDid.FailoverLocation,
    failoverProtocol: apiDid.FailoverProtocol,
    modified: apiDid.Modified,
    name: apiDid.Name,
    note: apiDid.Note,
    number: apiDid.Number,
    organizationId: apiDid.OrganizationId,
    protocol: apiDid.Protocol,
    simultaneousCallLimit: apiDid.SimultaneousCallLimit,
    timeout: apiDid.Timeout,
    userId: apiDid.UserId,
    userNumberAlias: apiDid.UserNumberAlias ? apiAliasToAlias(apiDid.UserNumberAlias) : undefined,
    userStatus: apiDid.UserStatus,
    voicemailboxId: apiDid.VoicemailboxId
  };
}
